export default __webpack_public_path__ + "static/media/lb_winAnim.54f552c0.png";